export const FEATURE_FLAGS = {
  LINE_CHART_REPORT: 'lineChartReports',
  DISPLAY_UPCOMING_MAINTENANCE: 'displayUpcomingMaintenance',
  DISABLE_NOTIFICATION_POLLING: 'disableNotificationPolling',
  ENABLE_AUTO_CASE_LINKING: 'exp-4326_auto_case_linking',
  ENABLE_FLEET_MANAGEMENT_MOCKS: 'exp-4646_fleet_management_mocks',
  PD_1188_ROUTE_BASED_FLEET_MANAGEMENT:
    'exp-PD-1188_route_based_fleet_management',
  // Registered disabled by managed-care-api migration
  // RegisterFleetAssetManagementFlag; keep the key in sync with it.
  PD_5874_FLEET_ASSET_MANAGEMENT: 'exp-PD-5874_fleet_asset_management',
} as const;
